import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, catchError, of, retry, Subject, throwError } from 'rxjs';
import { CustomerDuplicateLookupModel, CustomerScreenPopModel, PaginateQuery, PaginateResult, ViewOnlyType } from '../core/models';

@Injectable({ providedIn: 'root' })
export class CustomerService extends ApiService {
  private readonly customerRefreshSubject = new Subject<void>();

  constructor(http: HttpClient) {
    super(http, 'Customer');
  }

  public readonly customerRefresh$ = this.customerRefreshSubject.asObservable();

  public getApplicationsByViewId(id: string): Observable<ViewOnlyType[]> {
    const url = `${this.route()}/GetApplicationsViewOnly?id=${id}`;
    return this.http.get<ViewOnlyType[]>(url).pipe(retry(2));
  }

  public getMarketingByViewId(id: string): Observable<ViewOnlyType[]> {
    const url = `${this.route()}/GetMarketingViewOnly?id=${id}`;
    return this.http.get<ViewOnlyType[]>(url).pipe(retry(2));
  }

  public findCustomerByPhone(phone: string, skip: number = 0, take: number = 10): Observable<PaginateResult | CustomerDuplicateLookupModel[]> {
    const url = `${this.route()}/FindCustomersByPhone/${encodeURIComponent(phone)}?skip=${skip}&take=${take}`;
    return this.http.get<PaginateResult | CustomerDuplicateLookupModel[]>(url).pipe(retry(2));
  }

  public findScreenPopCustomers(paginate: PaginateQuery): Observable<PaginateResult & { list: CustomerScreenPopModel[] }> {
    const url = `${this.route()}/ScreenPopCustomers/Paginate`;
    return this.http.post<PaginateResult & { list: CustomerScreenPopModel[] }>(url, paginate).pipe(retry(2));
  }

  public paginateDeleted(data: PaginateQuery): Observable<PaginateResult> {
    const url = `${this.route()}/PaginateDeleted`;
    return this.http.post<PaginateResult>(url, data).pipe(
      catchError((error) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        }
        return throwError(() => error);
      }),
    );
  }

  public recover(id: string): Observable<void> {
    const url = `${this.route()}/${id}/Recover`;
    return this.http.patch<void>(url, null).pipe(retry(2));
  }

  public notifyCustomerRefresh(): void {
    this.customerRefreshSubject.next();
  }
}
